import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
// NOTE: This component should not be invoked directly. Instead, use the "FlyPowerSelect" component

import { action } from '@ember/object';
import PowerSelect from 'ember-power-select/components/power-select';
import { task } from 'ember-concurrency';
import { timeout, waitForProperty } from 'ember-concurrency';
import { widthInPixels } from '@customerio/fly-components/utils/string';
import { tracked } from '@glimmer/tracking';
import { isPowerSelectGroup } from '../../utils/power-select';
const SELECTED_ITEM_ICON_WIDTH = 20; //px
const ITEM_HORIZONTAL_PADDING = 12; //px
const ITEM_ICON_WIDTH = 14; //px
const ITEM_ICON_SPACING = 12; //px
const SCROLL_BAR_WIDTH = 20; //px

function mergeResults(currentItems, newItems) {
  let mergedItems = [];
  let newCopy = [...newItems];
  currentItems.forEach(i => {
    if (isPowerSelectGroup(i)) {
      let index = null;
      let sameGroupInNewItems = newCopy.find((newItem, copyIndex) => {
        let isSameGroup = isPowerSelectGroup(newItem) && newItem.groupName === i.groupName;
        if (isSameGroup) {
          index = copyIndex;
          return true;
        }
        return false;
      });
      if (sameGroupInNewItems != null && index != null) {
        newCopy.splice(index, 1);
        mergedItems.push({
          ...sameGroupInNewItems,
          options: mergeResults(i.options, sameGroupInNewItems.options)
        });
        return;
      }
    }
    mergedItems.push(i);
  });
  if (newCopy.length > 0) {
    mergedItems.push(...newCopy);
  }
  return mergedItems;
}
let PowerSelectExtended = (_class = class PowerSelectExtended extends PowerSelect {
  async _search(term) {
    if (term === this.searchText) {
      return;
    }
    this.enqueueLoadNextTask.cancelAll();
    this.loadNextTask.cancelAll();
    super._search(term);
    this.hasLoadedMore = false;
    this._canLoadMore = true;
    this.mergedResults = [];
    await waitForProperty(this, 'loading', l => !l);
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    if (!this.args.extra.itemWidth && this.args.extra.matchContentWidth) {
      this._resizeDropdownContent();
    }
  }

  // internal api

  get results() {
    if (this.hasLoadedMore) {
      return this.mergedResults;
    }
    return super.results;
  }

  // Load next page of results: chain of 3 funcs called when reaching end of the selectable results list
  // 1. performLoadNext: checks for handler to fetch the next page of results
  performLoadNext() {
    if (!this.args.extra.onScrollEnd) {
      return;
    }
    return this.enqueueLoadNextTask.perform();
  }

  // 2. enqueueLoadNextTask: debounced and re-startable to avoid trying to load multiple pages at the same time

  _getLongestLabel(results, labelProperty, secondaryLabelProperty) {
    // This will technically produce the longest label given that characters are monospace. While that's not perfect,
    // it's the best basis we have for determining if we need to recalculate the width. If cases are occurring where
    // horizontal scrollbars are appearing, consider increasing the EXTRA_ITEM_SPACING constant at the top of the file.
    return results.reduce((longestLabel, result) => {
      let resultLabelString;
      if (isPowerSelectGroup(result)) {
        resultLabelString = this._getLongestLabel(result.options, labelProperty);
      } else if (typeof result === 'object') {
        let labelValue = result[labelProperty];
        let secondaryLabelValue = secondaryLabelProperty ? result[secondaryLabelProperty] : undefined;
        resultLabelString = labelValue;
        if (secondaryLabelValue && labelValue.length < secondaryLabelValue.length) {
          resultLabelString = secondaryLabelValue;
        }
      } else {
        resultLabelString = result;
      }
      resultLabelString = (resultLabelString || '').toString();
      return resultLabelString.length > longestLabel.length ? resultLabelString : longestLabel;
    }, '');
  }
  _resizeDropdownContent() {
    if (!this.args.extra.matchContentWidth) {
      return;
    }
    let dropdownContentElement = document.getElementById(`ember-basic-dropdown-content-${this.storedAPI.uniqueId}`);
    if (!dropdownContentElement) {
      return;
    }
    if (this.args.extra.itemWidth) {
      dropdownContentElement.style.width = this.args.extra.itemWidth;
    } else {
      let newWidth;
      let {
        results,
        selected
      } = this.storedAPI;
      let longestLabel = this._getLongestLabel(results, this.args.extra.labelProperty, this.args.extra.secondaryLabelProperty);

      // If the selected items have changed since the last time the menu was opened, or if the longest label has changed due to a search
      if (this._longestLabel !== longestLabel || selected !== this._previouslySelectedItems) {
        // Add the padding of the list item to its labels with in pixels plus a nudge for wiggle room, account for scrollbar width
        newWidth = ITEM_HORIZONTAL_PADDING * 2 + widthInPixels(longestLabel) + SCROLL_BAR_WIDTH;
        if (this.args.extra.iconProperty) {
          newWidth = newWidth + ITEM_ICON_WIDTH + ITEM_ICON_SPACING;
        }
        if (this.args.extra.multiSelect) {
          newWidth = newWidth + SELECTED_ITEM_ICON_WIDTH;
        }
        this._longestLabel = longestLabel;
        this._previouslySelectedItems = selected;
        this._dropdownContentWidth = newWidth;
      }
      dropdownContentElement.style.width = `${this._dropdownContentWidth}px`;
    }
  }
  get mustShowNoMessages() {
    if (this.args.showNoMatches === false) {
      return false;
    }
    return super.mustShowNoMessages;
  }
  handleOpen(_select, e) {
    this.mergedResults = this.results;
    return super.handleOpen(_select, e);
  }
  handleClose(_select, e) {
    this.enqueueLoadNextTask.cancelAll();
    this.loadNextTask.cancelAll();
    this.hasLoadedMore = false;
    this._canLoadMore = true;
    return super.handleClose(_select, e);
  }
  constructor(owner, args) {
    super(owner, args);
    // Untracked properties
    _defineProperty(this, "_publicAPIActions", {
      search: this._search,
      highlight: this._highlight,
      select: this._select,
      choose: this._choose,
      scrollTo: this._scrollTo,
      // custom additions:
      resizeDropdownContent: this._resizeDropdownContent,
      loadNext: this.performLoadNext
    });
    _defineProperty(this, "args", void 0);
    _initializerDefineProperty(this, "_canLoadMore", _descriptor, this);
    _initializerDefineProperty(this, "_dropdownContentWidth", _descriptor2, this);
    _initializerDefineProperty(this, "_previouslySelectedItems", _descriptor3, this);
    _initializerDefineProperty(this, "_longestLabel", _descriptor4, this);
    _initializerDefineProperty(this, "hasLoadedMore", _descriptor5, this);
    _initializerDefineProperty(this, "mergedResults", _descriptor6, this);
    _defineProperty(this, "enqueueLoadNextTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(100);
        // If a "search" has been performed, wait for "loading" to finish -
        // otherwise loadNextTask might interfere with updating internal power
        // select states
        yield waitForProperty(this, 'loading', l => !l);

        // not returned on purpose, to avoid possible "loadNextTask" cancellation if "enqueueLoadNextTask" is called again
        this.loadNextTask.perform();
      }
    }), {
      restartable: true
    }, "enqueueLoadNextTask", null));
    // 3. loadNextTask: "enqueue: true" to ensure next pages are loaded and appended in the right order. Debouncing is already done in "enqueueLoadNextTask".
    _defineProperty(this, "loadNextTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        if (!this._canLoadMore) {
          return;
        }
        this.loading = true;
        let newOptions = null;
        try {
          newOptions = yield this.args.extra.onScrollEnd(this.searchText);
        } catch (e) {
          // no need to do anything extra
        }
        this._resetHighlighted();
        this.loading = false;
        if (newOptions == null) {
          // if no new options got returned, don't try appending them to the options list:
          return;
        }

        // hasLoadedMore tells results() getter to return "mergedResults" rather
        // than "super.results". This skips ember-power-select's built-in search,
        // because the assumption is that a fly-power-select that uses the
        // onScrollEnd feature to load paginated content also does
        // searching/filtering on its own. When a query is paginated, it doesn't
        // make sense for us to filter inside this component, since the API should
        // perform the filtering anyway.
        this.mergedResults = mergeResults(this.results, newOptions);
        this.hasLoadedMore = true;
        this._canLoadMore = newOptions.length !== 0;
        if (!this.args.extra.itemWidth && this.args.extra.matchContentWidth) {
          this._resizeDropdownContent();
        }
        return;
      }
    }), {
      enqueue: true
    }, "loadNextTask", null));
    this.args = args;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "_search", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_search"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_canLoadMore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_dropdownContentWidth", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_previouslySelectedItems", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_longestLabel", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasLoadedMore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "mergedResults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "performLoadNext", [action], Object.getOwnPropertyDescriptor(_class.prototype, "performLoadNext"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_resizeDropdownContent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_resizeDropdownContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype)), _class);
export { PowerSelectExtended as default };